import { createI18nInstance as o } from "../libs/util/dist/index24.mjs";
import e from "../locales/en/common.json.mjs";
const n = {
  en: { common: e }
}, { i18n: t } = o({
  compatibilityJSON: "v3",
  resources: n
});
export {
  t as i18n
};
